import React from "react";
import logo from "./logo.svg";
import "./App.css";
import PIO from "./PIO"


var alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export default class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ToAddress: "",
      From: "Adeeb Hussain",
      FromAddress:
        "No. 15, 2nd Cross,\nRajappa Block, J. C. Nagar,\nBangalore - 560006",
      PostalOrder: "",
      Reference: "",
      Subject: "",
      InformationRequired: [""],
      Annexures: [""],
      CopiedTo: [""]
    };
  }

  render() {

    return (
      <div className="App">
        <div className="Table">
          <div className="TableRow">
            <div className="TableMainCell">
              <div className="Table">
                <div className="TableRow">
                  <div className="TableLabelCell">Postal Order</div>
                  <div className="TableControlCell">
                    <input
                      type="text"
                      className="TextBox"
                      onChange={(e) =>
                        this.setState({ PostalOrder: e.target.value })
                      }
                      value={this.state.PostalOrder}
                    />
                  </div>
                </div>
                <div className="TableRow">
                  <div className="TableLabelCell">To</div>
                  <div className="TableControlCell">
                    Public Information Officer
                  </div>
                </div>
                <div className="TableRow">
                  <div className="TableLabelCell">Address</div>
                  <div className="TableControlCell">
                    <textarea
                      className="AddressBox"
                      onChange={(e) =>
                        this.setState({ ToAddress: e.target.value })
                      }
                      value={this.state.ToAddress}
                    ></textarea>
                  </div>
                </div>
                <div className="TableRow">
                  <div className="TableLabelCell">From</div>
                  <div className="TableControlCell">
                    <input
                      type="text"
                      className="TextBox"
                      onChange={(e) => this.setState({ From: e.target.value })}
                      value={this.state.From}
                    />
                  </div>
                </div>
                <div className="TableRow">
                  <div className="TableLabelCell">Address</div>
                  <div className="TableControlCell">
                    <textarea
                      className="AddressBox"
                      onChange={(e) =>
                        this.setState({ FromAddress: e.target.value })
                      }
                      value={this.state.FromAddress}
                    ></textarea>
                  </div>
                </div>
                <div className="TableRow">
                  <div className="TableLabelCell">Reference with</div>
                  <div className="TableControlCell">
                    <input
                      type="text"
                      className="TextBox"
                      onChange={(e) =>
                        this.setState({ Reference: e.target.value })
                      }
                      value={this.state.Reference}
                    />
                  </div>
                </div>
                <div className="TableRow">
                  <div className="TableLabelCell">RTI Subject</div>
                  <div className="TableControlCell">
                    <input
                      type="text"
                      className="TextBox"
                      onChange={(e) =>
                        this.setState({ Subject: e.target.value })
                      }
                      value={this.state.Subject}
                    />
                  </div>
                </div>
              </div>
              <div className="Table">
                <div className="TableRow">
                  <div className="TableLabelDoubleCell">
                    Information Required &nbsp;
                    <button
                      type="button"
                      onClick={() =>
                        this.setState((previousState) => ({
                          InformationRequired: [
                            ...previousState.InformationRequired,
                            "",
                          ],
                        }))
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
                {this.state.InformationRequired.map((info, idx) => (
                  <div className="TableRow">
                    <div className="TableControlCell">
                      {idx + 1})&nbsp;
                      <input
                        type="text"
                        className="TextBox"
                        style={{ width: "370px" }}
                        onChange={(e) => {
                          const updatedArray = [
                            ...this.state.InformationRequired,
                          ];
                          updatedArray[idx] = e.target.value;
                          this.setState({ InformationRequired: updatedArray });
                        }}
                        value={this.state.InformationRequired[idx]}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          this.setState({
                            InformationRequired: this.state.InformationRequired.filter(
                              (i) => i !== this.state.InformationRequired[idx]
                            ),
                          });
                        }}
                      >
                        -
                      </button>
                    </div>
                  </div>
                ))}
                <div className="TableRow">
                  <div className="TableLabelCell">
                    Annexures &nbsp;
                    <button
                      type="button"
                      onClick={() =>
                        this.setState((previousState) => ({
                          Annexures: [...previousState.Annexures, ""],
                        }))
                      }
                    >
                      +
                    </button>
                  </div>
                  <div className="TableControlCell"></div>
                </div>
                {this.state.Annexures.map((Annexure, idx) => (
                  <div className="TableRow">
                    <div className="TableControlCell">
                      {alphabets.charAt(idx)})&nbsp;
                      <input
                        type="text"
                        className="TextBox"
                        style={{ width: "370px" }}
                        onChange={(e) => {
                          const updatedArray = [...this.state.Annexures];
                          updatedArray[idx] = e.target.value;
                          this.setState({ Annexures: updatedArray });
                        }}
                        value={this.state.Annexures[idx]}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          this.setState({
                            Annexures: this.state.Annexures.filter(
                              (i) => i !== this.state.Annexures[idx]
                            ),
                          });
                        }}
                      >
                        -
                      </button>
                    </div>
                  </div>
                ))}

                <div className="TableRow">
                  <div className="TableLabelCell">
                    Copied To:&nbsp;
                    <button
                      type="button"
                      onClick={() =>
                        this.setState((previousState) => ({
                          CopiedTo: [...previousState.CopiedTo, ""],
                        }))
                      }
                    >
                      +
                    </button>
                  </div>
                  <div className="TableControlCell"></div>
                </div>
                {this.state.CopiedTo.map((Copied, idx) => (
                  <div className="TableRow">
                    <div className="TableControlCell">
                      <textarea
                        className="AddressBox"
                        style={{ width: "350px" }}
                        onChange={(e) => {
                          const copiedToArray = [...this.state.CopiedTo];
                          copiedToArray[idx] = e.target.value;
                          this.setState({ CopiedTo: copiedToArray });
                        }}
                        value={this.state.CopiedTo[idx]}
                      ></textarea>
                      &nbsp;
                      <button
                        type="button"
                        style={{ "paddingTop": "0px" }}
                        onClick={() => {
                          this.setState({
                            CopiedTo: this.state.CopiedTo.filter(
                              (i) => i !== this.state.CopiedTo[idx]
                            ),
                          });
                        }}
                      >
                        -
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <PIO ToAddress={this.state.ToAddress} From={this.state.From} FromAddress={this.state.FromAddress}
              Subject={this.state.Subject} Reference={this.state.Reference} InformationRequired={this.state.InformationRequired}
              PostalOrder={this.state.PostalOrder} Annexures={this.state.Annexures} CopiedTo={this.state.CopiedTo} />
          </div>
        </div>
      </div >
    );
  }
}
